// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"43bcda3e","143":"f4938cf8","533":"af354c9c","596":"82d835d4","730":"bdb712b7","788":"fa291c75"}[chunkId] + ".chunk.js";
};